import BellSvg from "img/notification-bell.svg"
import AlertSvg from "img/notification-alert.svg"
import InfoSolidSvg from "img/info-solid.svg"
import TickIconSvg from "img/notification-tick.svg"
import QuestionIconSvg from "img/notification-question.svg"
import envelopeSvg from "img/002-envelope.svg"
import FileSvg from "img/blue-document.svg"

import { ImgHTMLAttributes } from "react"
import Loader from "@components/Loader/Loader"

export const BellIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      height="35"
      src={BellSvg}
      alt=""
      role="presentation"
      className="bell-icon"
      {...props}
    />
  )
}

export const AlertIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      height="29"
      src={AlertSvg}
      alt=""
      role="presentation"
      className="alert-icon"
      {...props}
    />
  )
}

export const InfoIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      height="35"
      src={InfoSolidSvg}
      alt=""
      role="presentation"
      className="info-icon"
      {...props}
    />
  )
}

export const TickIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      height="30"
      src={TickIconSvg}
      alt=""
      role="presentation"
      className="tick-icon"
      {...props}
    />
  )
}

export const HelpIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      height="35"
      src={QuestionIconSvg}
      alt=""
      role="presentation"
      className="question-icon"
      {...props}
    />
  )
}

export const EnvelopeIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      height="20"
      src={envelopeSvg}
      alt=""
      role="presentation"
      className="info-icon"
      {...props}
    />
  )
}

export const FileIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      height="45"
      src={FileSvg}
      alt=""
      role="presentation"
      className="info-icon"
      {...props}
    />
  )
}

export interface NotificationIconProps {
  /**
   * Will return an icon if one of the set string values
   */
  type:
    | "bell"
    | "bell-alert"
    | "alert"
    | "info"
    | "info-text"
    | "success"
    | "help"
    | "mail"
    | "file"
    | "loader"
    | string
}

const NotificationIcon = ({ type }: NotificationIconProps) => {
  switch (type) {
    case "bell":
      return <BellIcon />

    case "bell-alert":
      return <BellIcon />

    case "alert":
      return <AlertIcon />

    case "info":
      return <InfoIcon />

    case "info-text":
      return <InfoIcon />

    case "success":
      return <TickIcon />

    case "help":
      return <HelpIcon />

    case "mail":
      return <EnvelopeIcon />

    case "file":
      return <FileIcon />

    case "loader":
      return <Loader inline={true} />

    default:
      return null
  }
}

export default NotificationIcon
